import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { HttpService } from '@sdbn/appclient';
import { ViewChild } from '@angular/core';
import { NgModel, NgForm } from '@angular/forms';
import { Transport } from './../model/transport';

import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TransportIssue } from '../model/transport-issue';
import { ResponseMessage } from '@sdbn/appclient';
import { ConfigurationService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-transport-issues-dialog',
  templateUrl: './transport-issues-dialog.component.html',
  styleUrls: ['./transport-issues-dialog.component.scss']
})
export class TransportIssuesDialogComponent implements OnInit {

  isLoading = false;

  @ViewChild('editForm', { static: true }) editForm: NgForm;

  responseMessages: ResponseMessage[] = [];

  newIssueId = 0;

  constructor(
    public dialogRef: MatDialogRef<TransportIssuesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public transport: Transport,
    public translationService: TranslationService,
    private httpService: HttpService,
    public cps: ConfigurationService
  ) { }

  ngOnInit() { }

  public cancel() {
    this.dialogRef.close();
  }

  public isSaveDisabled() {
    return this.isLoading || this.editForm.invalid;
  }

  public isAddIssueDisabled() {
    return this.isLoading;
  }

  public save() {

    this.isLoading = true;
    this.responseMessages = [];

    this.httpService.postWithContext<ServiceResponse>(environment.transportIssuesEndpoint + '/save', this.transport).subscribe(
      response => {
        if (ServiceResponse.isFailed(response)) {
          this.responseMessages = this.responseMessages;
        } else {
          this.dialogRef.close();
        }
        this.isLoading = false;
      }, error => {
        console.log('error while savin transport issues' + error);
        this.isLoading = false;
      }
    );
  }

  public addIssue() {

    const newIssue = new TransportIssue();
    newIssue.id = --this.newIssueId;
    if (this.transport.issueTypes != null && this.transport.issueTypes.length > 0) {
      newIssue.issueTypeId = this.transport.issueTypes[0].id;
      newIssue.delay = this.transport.issueTypes[0].delay;
    }

    this.transport.transportIssues.push(newIssue);
  }

  public isRemoveIssueDisabled(issue: TransportIssue) {
    return this.isLoading;
  }

  public removeIssue(issue: TransportIssue) {
    if (issue.id > 0) {
      issue.deleted = true;
    } else {
      const index = this.transport.transportIssues.indexOf(issue);
      this.transport.transportIssues.splice(index, 1);
    }
  }

  public showValuePositiveIntegerError(ctrl: NgModel) {
    return ctrl.touched && ctrl.hasError('positiveInteger');
  }

  public getNonDeletedIssues() {
    return this.transport.transportIssues.filter(i => !i.deleted);
  }

  /**
   * Prevents events on keydown.enter in the form.
   * Must return false!
   */
  public preventEnterKeydown(): boolean {
    return false;
  }

  public onTypeSelectionChange(event: any, issue: TransportIssue) {
    if (this.transport.issueTypes != null) {
      const type = this.transport.issueTypes.find(i => i.id === event.value);
      issue.delay = type.delay;
    }
  }
}
